// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"bfa17b2c","130":"7b76edfa","150":"34c3d14c","161":"60e95206","272":"b884e671","490":"29d05a13","534":"29dab712","686":"83c81ad4","691":"9461310c","719":"26fdb1a7","860":"41fad61a"}[chunkId] + ".chunk.js";
};